module.exports = __webpack_public_path__ + "fonts/CircularSpUIv3T-Black.c21e63c.woff2";